module.exports = __webpack_public_path__ + "static/media/8.1.ebdd8c3e.png";